import React from "react";
import styles from "../Modules/InfoCard.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faExternalLinkAlt, faCode } from "@fortawesome/free-solid-svg-icons";
import { faGithub } from "@fortawesome/free-brands-svg-icons";

class InfoCard extends React.Component {
  static getDerivedStateFromProps(props) {
    return {
      demo:                    props.demo,
      demoVideo:               props.demoVideo,
      projectName:             props.name,
      codeLink:                props.gitRepo,
      projectLogo:             props.logo,
      projectTechnologies:     props.projectTechnologies,
      projectDescription:      props.projectDescription,
      projectFunctionalities:  props.projectFunctionalities,
      projectModeling:         props.projectModeling,
      imgAlt:                  props.imgAlt,
      functionalitiesPics:     props.functionalitiesPics,
      modelingPics:            props.modelingPics,
      backgroundPicture:       props.backgroundPicture,
      backgrounds_attributions: props.backgrounds_attributions,
    };
  }

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      demo, demoVideo, projectName, codeLink, projectLogo,
      projectTechnologies, projectDescription, projectFunctionalities,
      projectModeling, functionalitiesPics, modelingPics,
      backgroundPicture, backgrounds_attributions,
    } = this.state;

    return (
      <div className={styles.page}>

        {/* ── Top bar ── */}
        <nav className={styles.topbar}>
          <a className={styles.backBtn} href={"/#" + projectName} title="Back to portfolio">
            <FontAwesomeIcon icon={faArrowLeft} />
            <span>Back</span>
          </a>
          <span className={styles.topbarName}>{projectName}</span>
          <div className={styles.topbarActions}>
            {demo && (
              <a className={styles.topbarLink} href={demo} target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faExternalLinkAlt} />
                <span>Demo</span>
              </a>
            )}
            {demoVideo && (
              <a className={styles.topbarLink} href={demoVideo} target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faExternalLinkAlt} />
                <span>Watch Demo</span>
              </a>
            )}
            <a className={styles.topbarLink} href={codeLink} target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faGithub} />
              <span>Source</span>
            </a>
          </div>
        </nav>

        {/* ── Hero ── */}
        <div className={styles.hero}>
          <img src={backgroundPicture} alt="project background" className={styles.heroBg} />
          <div className={styles.heroOverlay} />
          <div className={styles.heroContent}>
            {projectLogo && (
              <div className={styles.logoWrap}>
                <img src={projectLogo} alt={projectName + " logo"} className={styles.logo} />
              </div>
            )}
            <h1 className={styles.heroTitle}>{projectName}</h1>
            <div className={styles.techList}>
              {(projectTechnologies || []).map((t) => (
                <span key={t} className={styles.techBadge}>{t}</span>
              ))}
            </div>
            <div className={styles.heroCtas}>
              {demo && (
                <a className={styles.ctaPrimary} href={demo} target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faExternalLinkAlt} /> Live Demo
                </a>
              )}
              <a className={styles.ctaSecondary} href={codeLink} target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faGithub} /> Source Code
              </a>
            </div>
          </div>
        </div>

        {/* ── Body ── */}
        <div className={styles.body}>
          {/* Sidebar */}
          <aside className={styles.sidebar}>
            <p className={styles.sidebarLabel}>Contents</p>
            <a className={styles.sidebarLink} href="#description">Description</a>
            <a className={styles.sidebarLink} href="#functionalities">Functionalities</a>
            {projectModeling && (
              <a className={styles.sidebarLink} href="#modeling">Modeling & Diagrams</a>
            )}
            {demoVideo && (
              <a className={styles.sidebarLink} href="#demo-video">Demo Video</a>
            )}
          </aside>

          {/* Main content */}
          <main className={styles.content}>
            {/* Description */}
            <section id="description" className={styles.section}>
              <span className={styles.sectionEyebrow}>Overview</span>
              <h2 className={styles.sectionHeading}>Description</h2>
              <p className={styles.bodyText}>{projectDescription}</p>
            </section>

            {/* Functionalities */}
            <section id="functionalities" className={styles.section}>
              <span className={styles.sectionEyebrow}>Features</span>
              <h2 className={styles.sectionHeading}>Functionalities</h2>
              {functionalitiesPics && (
                <div className={styles.imageWrap}>
                  <img src={functionalitiesPics} alt="project screenshot" className={styles.sectionImg} />
                </div>
              )}
              <p className={styles.bodyText}>{projectFunctionalities}</p>
            </section>

            {/* Modeling */}
            {projectModeling && (
              <section id="modeling" className={styles.section}>
                <span className={styles.sectionEyebrow}>Architecture</span>
                <h2 className={styles.sectionHeading}>Modeling & Diagrams</h2>
                {modelingPics && (
                  <div className={styles.imageWrap}>
                    <img src={modelingPics} alt="project diagram" className={styles.sectionImg} />
                  </div>
                )}
                <p className={styles.bodyText}>{projectModeling}</p>
              </section>
            )}

            {/* Demo video */}
            {demoVideo && (
              <section id="demo-video" className={styles.section}>
                <span className={styles.sectionEyebrow}>Watch</span>
                <h2 className={styles.sectionHeading}>Demo Video</h2>
                <div className={styles.videoWrap}>
                  <iframe
                    title="project demonstration video"
                    src={demoVideo}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
              </section>
            )}
          </main>
        </div>

        {/* ── Footer ── */}
        <footer className={styles.footer}>
          {backgrounds_attributions && (
            <span className={styles.attribution}>{backgrounds_attributions}</span>
          )}
          <span className={styles.footerCopy}>
            © {new Date().getFullYear()} Soulaimane ELManioui
          </span>
        </footer>
      </div>
    );
  }
}

export default InfoCard;
